module.exports = __webpack_public_path__ + "img/csm__MG_8481_ab32d87542.11a9f977.jpg";